import { Box, NumberInput, Popover, Slider } from "@wix/design-system";
import React from "react";
const InputWithSlider = ({
  value,
  onChange,
  gradientColor,
  zIndex,
  suffix,
  min,
  max,
  dataHook
}) => {
  const [isSliderVisible, setIsSliderVisible] = React.useState(false);
  const inputWrapperRef = React.useRef(null);
  const inputWrapperDimensions = inputWrapperRef.current?.getBoundingClientRect() ?? { width: 0 };
  const popoverZIndex = `calc(${zIndex} + 100)`;
  const numberInputZIndex = `calc(${popoverZIndex} + 1)`;
  const rightPadding = 6;
  return /* @__PURE__ */ React.createElement(
    Popover,
    {
      shown: isSliderVisible,
      placement: "right",
      moveBy: { x: -1 * inputWrapperDimensions.width - rightPadding },
      zIndex: popoverZIndex,
      onClickOutside: () => setIsSliderVisible(false)
    },
    /* @__PURE__ */ React.createElement(Popover.Element, null, /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: inputWrapperRef,
        style: isSliderVisible ? { position: "relative", zIndex: numberInputZIndex } : void 0
      },
      /* @__PURE__ */ React.createElement(
        NumberInput,
        {
          size: "small",
          suffix,
          value,
          min,
          max,
          onFocus: () => setIsSliderVisible(true),
          onChange: (value2) => onChange(value2 ?? 100),
          hideStepper: true,
          dataHook
        }
      )
    )),
    /* @__PURE__ */ React.createElement(Popover.Content, null, /* @__PURE__ */ React.createElement(Box, { padding: `6px ${rightPadding}px 6px 12px`, gap: "SP3" }, /* @__PURE__ */ React.createElement(Box, { width: 88 }, /* @__PURE__ */ React.createElement(
      Slider,
      {
        gradientColor,
        displayMarks: false,
        min,
        max,
        value,
        onChange: (value2) => onChange(typeof value2 === "number" ? value2 : value2[0]),
        displayTooltip: false
      }
    )), /* @__PURE__ */ React.createElement(Box, { width: inputWrapperDimensions.width })))
  );
};
export {
  InputWithSlider
};
//# sourceMappingURL=input-with-slider.js.map
